(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after-slider')) {
    class BeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        this.handle = this.querySelector('.ba__handle');
        if (!this.handle) return;

        this.vertical = this.dataset.orientation === 'vertical';
        this.hoverMode = this.dataset.mode === 'hover';
        this.initial = parseFloat(this.dataset.position);
        if (isNaN(this.initial)) this.initial = 50;
        this.dragging = false;
        this.animating = false;

        this.onDown = this.onDown.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);
        this.onKey = this.onKey.bind(this);

        this.addEventListener('pointerdown', this.onDown);
        this.addEventListener('pointermove', this.onMove);
        this.addEventListener('pointerup', this.onUp);
        this.addEventListener('pointercancel', this.onUp);
        this.handle.addEventListener('keydown', this.onKey);

        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.intro === 'true' && !reduceMotion && 'IntersectionObserver' in window) {
          this.setPosition(4);
          this.observer = new IntersectionObserver(
            function (entries) {
              if (entries[0].isIntersecting) {
                this.observer.disconnect();
                this.playIntro();
              }
            }.bind(this),
            { threshold: 0.4 }
          );
          this.observer.observe(this);
        } else {
          this.setPosition(this.initial);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.animating = false;
      }

      playIntro() {
        var start = performance.now();
        var from = 4;
        var to = this.initial;
        var duration = 1400;
        this.animating = true;

        var step = function (now) {
          if (!this.animating) return;
          var t = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - t, 3);
          this.setPosition(from + (to - from) * eased);
          if (t < 1) requestAnimationFrame(step);
          else this.animating = false;
        }.bind(this);

        requestAnimationFrame(step);
      }

      setPosition(percent) {
        percent = Math.max(0, Math.min(100, percent));
        this.position = percent;
        this.style.setProperty('--position', percent + '%');
        this.handle.setAttribute('aria-valuenow', Math.round(percent));
      }

      updateFromEvent(event) {
        var rect = this.getBoundingClientRect();
        var percent = this.vertical
          ? ((event.clientY - rect.top) / rect.height) * 100
          : ((event.clientX - rect.left) / rect.width) * 100;
        this.setPosition(percent);
      }

      onDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.animating = false;
        this.dragging = true;
        this.classList.add('is-dragging');
        try { this.setPointerCapture(event.pointerId); } catch (e) {}
        this.updateFromEvent(event);
      }

      onMove(event) {
        if (this.dragging || (this.hoverMode && event.pointerType === 'mouse')) {
          this.animating = false;
          this.updateFromEvent(event);
        }
      }

      onUp(event) {
        this.dragging = false;
        this.classList.remove('is-dragging');
        try { this.releasePointerCapture(event.pointerId); } catch (e) {}
      }

      onKey(event) {
        var step = event.shiftKey ? 10 : 5;
        var handled = true;

        switch (event.key) {
          case 'ArrowLeft':
          case 'ArrowUp':
            this.setPosition(this.position - step);
            break;
          case 'ArrowRight':
          case 'ArrowDown':
            this.setPosition(this.position + step);
            break;
          case 'Home':
            this.setPosition(0);
            break;
          case 'End':
            this.setPosition(100);
            break;
          default:
            handled = false;
        }

        if (handled) {
          this.animating = false;
          event.preventDefault();
        }
      }
    }

    customElements.define('before-after-slider', BeforeAfterSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Custom: toggles .is-scrolled on the header section (used by the transparent header and scroll shadow) */
  (function () {
    var section = null;

    function update() {
      if (!section) return;
      var y = window.pageYOffset || document.documentElement.scrollTop;
      section.classList.toggle('is-scrolled', y > 10);
    }

    function setHeight() {
      if (!section) return;
      document.documentElement.style.setProperty('--header-height', section.offsetHeight + 'px');
    }

    function init() {
      section = document.querySelector('.section-header');
      if (!section) return;
      window.removeEventListener('scroll', update);
      window.addEventListener('scroll', update, { passive: true });
      window.removeEventListener('resize', setHeight);
      window.addEventListener('resize', setHeight);
      window.removeEventListener('load', setHeight);
      window.addEventListener('load', setHeight);
      update();
      setHeight();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  /* Side arrows: forward the click to the slideshow's own previous/next buttons */
  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('.slideshow__side-arrow');
    if (!arrow) return;
    var component = arrow.closest('slideshow-component');
    if (!component) return;
    var target = component.querySelector('button[name="' + arrow.getAttribute('data-direction') + '"]');
    if (target) target.click();
  });

  } catch(e) { console.error(e); }
})();
})();
